import { ModuleTopmostTracking } from "./moduleTopmostTracking";
import { ModuleTopmostTabbs } from "./moduleTopmostTabbs";
import { ModuleRecomendationsTracking } from "./moduleRecomendationsTracking";


export class ModuleInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new ModuleTopmostTracking();
        new ModuleTopmostTabbs();
        new ModuleRecomendationsTracking();
    }
}
